/* 樂進（字文謙） */
import { defineHero, hook } from '../define.ts';

export default defineHero({
  id: 'yuejin', name: '樂進', sub: '字文謙', faction: 'wei', role: '刺客', weapon: 'sword',
  look: { size: 0.94, fx: '#ffe28a', c: { plume: '#e9c46a' } },
  skills: [
    ['先登', 'charge', '搶先衝鋒，造成 {80/125/170/215} 傷害並暈眩 0.5 秒。'],
    ['驍果', 'multi', '三連斬，每段 {60/95/130/165} 傷害。'],
    ['膽烈', 'passive', '攻擊目前生命比自己高的目標時，傷害 +{12/17/22/27}%。', { pv: {}, sig: 'daring', amp: [12, 17, 22, 27] }],
    ['奪城', 'slam', '躍起一擊，造成 {360/520/680} 傷害並暈眩 0.6 秒。'],
  ],
  // 被動與專屬效果：hook(時間點, 順位, 處理)（時間點一覽見 core/hooks.ts）
  hooks: [
    // 膽烈：打目前生命比自己高的人
    hook('damage.before', 90, function (c) { const own0 = c.own; if (own0.sg && own0.sg.daring && c.t.hp > own0.hp) c.a *= 1 + own0.sg.daring.v('amp') / 100; }),
  ],
});
